import Pagination from "../../publisher/Pagination";
import SerpPagination from "./SerpPagination";
import SerpFilters from "./SerpFilters";
import SerpSorting from "./SerpSorting";
import SerpContact from "./SerpContact";
import PageData from "../../PageData";
import {ProjectsSerp} from "./ProjectsSerp";
import {ForeclosureExcluded} from "./ForeclosureExcluded";
import {connect} from "../../connect";
import FiltersFormBar from "./FiltersFormBar";
import {MarketStatsChartVersion, SerpMarketStatsChart} from "../../components/charts/SerpMarketStatsChart";
import {MarketStatsMultiChartSelectorSubscriber, MarketStatsStyles} from "../../components/charts/MarketStatsChart";
import http from "../../core/http";
import {expose} from "../../components/core/amplitude";
import {MarketStatsTracking} from "../../core/tracking/MarketStatsTracking";
import "../../webcomponents/typeform/typeform.component";
import {initPersonalAssistant} from "../../core/experimental/personalAssistant";

(window as any).initPage = (pagination: Pagination, pageData: PageData) => {
    const filtersFormBar = new FiltersFormBar();

    connect(() => {
        if (pagination) new SerpPagination(pagination).init();
        new SerpFilters(filtersFormBar).init();
        new SerpSorting(onSortingChange);
        new SerpContact(pageData).init()
        new ProjectsSerp().init()
        new ForeclosureExcluded(filtersFormBar).init()
        const marketStatsStyles: MarketStatsStyles = {
            lineColor: '#1E4FB1',
            fillColor: '#3366CC1A',
            pointColor: '#FFFFFF',
            pointHoverColor: '#1E4FB1',
            axisBorderColor: '#4A4A4A',
            scalesLabelColor: '#4A4A4A',
            pointRadius: 8,
            tickPadding: 10,
            tooltipTitleFontSize: 14,
            tooltipBodyFontSize: 16,
            chartType: 'line',
            xAxisRotation: false,
            yAxisRotation: false,
            barThickness: undefined,
            barBorderRadius: undefined,
        };
        new SerpMarketStatsChart().init(marketStatsStyles);
        const marketStatsFallbackSelectors = new MarketStatsMultiChartSelectorSubscriber(1, '.market-stats-fallback-selector-geo', '.market-stats-fallback-selector-price-type');
        new SerpMarketStatsChart().init(marketStatsStyles, '.js-serp-market-stats-fallback-chart', MarketStatsChartVersion.WITH_POINTS, marketStatsFallbackSelectors);
        new MarketStatsTracking().init(pageData);
        initPersonalAssistant()
        http.init();
        expose().then(_ => {});
    });

    function onSortingChange() {
        filtersFormBar.submit()
    }
}
